module.exports = __webpack_public_path__ + "static/media/low-battery.fd9ec030.svg";